import { deriveRacquetDurationOptions, getPreferredRacquetDuration, isValidRacquetDurationSelection } from '@/utils/racquetBookingDurations'

export function deriveMemberPortalRacquetDurationOptions({ court, maxAllowedMinutes } = {}) {
  return deriveRacquetDurationOptions({ court, maxAllowedMinutes })
}

export function getPreferredMemberPortalRacquetDuration({ requestedDuration, court, durationOptions } = {}) {
  return getPreferredRacquetDuration({ requestedDuration, court, durationOptions })
}

export function isValidMemberPortalRacquetDurationSelection(durationMinutes, durationOptions = []) {
  return isValidRacquetDurationSelection(durationMinutes, durationOptions)
}
